import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

interface ResourceDetailExtraInformationWrapperProps {
  columns: number;
}

export const ResourceDetailExtraInformationWrapper = styled.div<ResourceDetailExtraInformationWrapperProps>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);

  ${BREAKPOINTS.large_tablet_landscape} {
    grid-template-columns: repeat(1, 1fr);
  }

  gap: 16px;
`;

export const ResourceDetailExtraInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ResourceDetailExtraInformationImpactMetricsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

interface ResourceDetailExtraInformationImpactMetricsProps {
  $isExpanded: boolean;
}

export const ResourceDetailExtraInformationImpactMetrics = styled.span<ResourceDetailExtraInformationImpactMetricsProps>`
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  white-space: break-spaces;

  color: var(--color-text);

  max-height: ${({ $isExpanded }) => ($isExpanded ? 'none' : '180px')};
  overflow: ${({ $isExpanded }) => ($isExpanded ? 'visible' : 'hidden')};
  transition: max-height 0.3s ease-in-out;
`;

export const ResourceDetailExtraInformationShowMoreButton = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: 30px;

  color: var(--color-text);

  cursor: pointer;
`;

export const ResourceDetailExtraInformationDataWrapper = styled.div`
  display: grid;
  grid-template-columns: 76px 1fr;
  grid-row-gap: 20px;
  grid-column-gap: 12px;
`;

export const ResourceDetailExtraInformationDataLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const ResourceDetailExtraInformationDataPills = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`;
